const T = require('prop-types');
const { default: Styled } = require('styled-components');
const { default: MuiFormControl } = require('@mui/material/FormControl');
const { default: Select } = require('@mui/material/Select');
const { default: InputLabel } = require('@mui/material/InputLabel');
const { default: MenuItem } = require('@mui/material/MenuItem');
const DropdownOptionStyles = require('hooks/useFormPrimitives/dropdownOptionStyles');
const { singleLineFieldStyles } = require('hooks/useFormPrimitives/singleLineFieldStyles');

const internals = {};

module.exports = function SelectField(props) {

    const {
        value,
        options,
        onChange,
        variant = 'outlined',
        includeSelect = false,
        label,
        labelId,
        inputProps = {},
        MenuProps = {},
        ...rest
    } = props;

    const {
        FormControl,
        SelectInputLabel,
        SelectMenuItem
    } = internals;

    const optionCount = [].concat(options).filter(Boolean).length + (includeSelect ? 1 : 0);
    const mergedMenuProps = DropdownOptionStyles.mergeLimitedMenuProps(
        MenuProps,
        DropdownOptionStyles.getVisibleMenuItemCount(optionCount)
    );

    if (labelId) {
        inputProps['aria-labelledby'] = labelId;
    }

    return (
        <FormControl fullWidth variant={variant}>
            {label && <SelectInputLabel id={labelId}>{label}</SelectInputLabel>}
            <Select
                labelId={labelId}
                inputProps={inputProps}
                variant={variant}
                fullWidth
                value={value}
                onChange={onChange}
                MenuProps={mergedMenuProps}
                {...rest}
            >
                {includeSelect && <SelectMenuItem value='' key='select' aria-label='Select'>Select...</SelectMenuItem>}
                {[].concat(options).filter(Boolean).map(({ value: optionValue, label: optionLabel }) => {

                    return (
                        <SelectMenuItem
                            value={optionValue}
                            key={optionLabel}
                            aria-label={optionLabel}
                        >
                            {optionLabel}
                        </SelectMenuItem>
                    );
                })}
            </Select>
        </FormControl>
    );
};

module.exports.propTypes = {
    value: T.any,
    options: T.arrayOf(T.shape({
        value: T.any
    })).isRequired,
    variant: T.oneOf(['standard', 'outlined']),
    onChange: T.func,
    includeSelect: T.bool,
    label: T.string,
    labelId: T.string,
    className: T.string,
    inputProps: T.object,
    MenuProps: T.object
};

internals.FormControl = Styled(MuiFormControl)`
    ${singleLineFieldStyles}
`;

internals.SelectInputLabel = Styled(InputLabel)`
    background: white;
    padding: 0 6px;
    margin-left: -6px;
`;

internals.SelectMenuItem = Styled(MenuItem)`
    ${DropdownOptionStyles.option}
`;
